import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  transaction: null,
  transactions: [],
  credit: null,
  credits: [],
  creditsPageNum: 0,
  totalCredits: null,
  creditBal: null,
  settlement: null,
  settlements: [],
  paymentLink: null,
  paymentLinks: [],
};

const slice = createSlice({
  name: 'cashflow',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TRANSACTIONS LIST
    getTransactionsSuccess(state, action) {
      state.isLoading = false;
      state.transactions = action.payload.items;
    },

    // GET TRANSACTION DETAILS
    getTransactionDetailSuccess(state, action) {
      state.isLoading = false;
      state.transaction = action.payload;
    },

    // GET CREDITS LIST
    getCreditsSuccess(state, action) {
      state.isLoading = false;
      // if (!state.creditsPageNum) {
      //   state.credits = action.payload.items;
      //   state.creditBal = action.payload.balance;
      // } else if (action.payload.page > state.creditsPageNum) {
      //   state.credits.push(...action.payload.items);
      //   state.creditBal = action.payload.balance;
      // }
      state.credits = action.payload.items;
      state.creditBal = action.payload.balance;
      state.totalCredits = action.payload.total;
      state.creditsPageNum = action.payload.page;
    },

    // GET CREDIT DETAILS
    getCreditDetailSuccess(state, action) {
      state.isLoading = false;
      state.credit = action.payload;
    },

    // UPDATE TRANSACTION DETAILS
    updateBookmarkSuccess(state, action) {
      state.isLoading = false;
    },

    // UPDATE TRANSACTION DETAILS
    updateTransactionDetailSuccess(state, action) {
      state.isLoading = false;
      state.transaction = action.payload;
    },

    // SEND PAYMENT LINK
    sendPaymentLinkSuccess(state, action) {
      state.isLoading = false;
    },

    // GET ALL PAYMENT LINKS
    getPaymentLinksSuccess(state, action) {
      state.isLoading = false;
      state.paymentLinks = action.payload;
    },

    // CANCEL PAYMENT LINK
    createPaymentLinkSuccess(state, action) {
      state.isLoading = false;
      state.paymentLink = action.payload;
    },

    // CANCEL PAYMENT LINK
    updatePaymentLinkSuccess(state, action) {
      state.isLoading = false;
      state.paymentLink = action.payload;
    },

    // CANCEL PAYMENT LINK
    cancelPaymentLinksSuccess(state, action) {
      state.isLoading = false;
      state.paymentLink = null;
    },

    // RESET APPLICATION
    resetPaymentLink(state) {
      state.isLoading = false;
      state.paymentLink = null;
      console.log('reset payment Link');
    },

  },
});

// Reducer
export default slice.reducer;

// Actions
export const { resetPaymentLink } = slice.actions;

// ----------------------------------------------------------------------

export function getTransactions() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/cashflow/payments/query');
      dispatch(slice.actions.getTransactionsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getCredits(page) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      console.log('came to redux engine with page', page)
      const response = await axios.post('/cashflow/credits/get_history', {page});
      dispatch(slice.actions.getCreditsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createPaymentLink(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/cashflow/payment_links/create', data);
      dispatch(slice.actions.createPaymentLinkSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePaymentLink(data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/cashflow/payment_links/update', data);
      dispatch(slice.actions.updatePaymentLinkSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function cancelPaymentLink(applicationId, cancellationReason) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/creditline/application/cancel', {
        applicationId,
        cancellationReason
      });
      dispatch(slice.actions.cancelApplicationSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateBookmark() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/cashflow/payments/bookmark_transaction');
      dispatch(slice.actions.updateBookmarkSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
